import React from "react";
import { any, string, bool } from "prop-types";

const LinkView = ({ className = "", link, children, openInNewTab = true }) => {
  const params = {};

  if (openInNewTab) {
    params.target = "_blank";
    params.rel = "nofollow";
  }

  return (
    <a className={className} href={link} {...params}>
      {children}
    </a>
  );
};

LinkView.propTypes = {
  children: any.isRequired,
  link: string.isRequired,
  className: string,
  openInNewTab: bool,
};

export default LinkView;
